import { get } from 'lodash';
import { http } from 'lib/services/http';
import { getErrorMessage } from 'utils/api-normalizers';
import {
  RESET_STATUS_REQUEST,
  RESET_STATUS_SUCCESS,
  RESET_STATUS_FAILURE,
  RESET_DATA_REQUEST,
  RESET_DATA_SUCCESS,
  RESET_DATA_FAILURE,
} from './types';

const RESET_STATUS_API_PATH = '/platform-admin/v1/reset/status';
const RESET_DATA_API_PATH = '/platform-admin/v1/reset';

export const getResetStatus = (params, setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: RESET_STATUS_REQUEST });

    return http
      .get(RESET_STATUS_API_PATH, { params })
      .then((payload) => {
        dispatch({ type: RESET_STATUS_SUCCESS, payload });
      })
      .catch((error) => {
        setSnackbar({
          message:
            get(error, 'errors[0].detail') ||
            'Checking reset data status failure!',
          severity: 'error',
        });
        dispatch({ type: RESET_STATUS_FAILURE, payload: error });
      });
  };
};

export const resetData = (setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: RESET_DATA_REQUEST });

    return http
      .post(RESET_DATA_API_PATH)
      .then((payload) => {
        dispatch({ type: RESET_DATA_SUCCESS, payload });
        setSnackbar({
          message: 'Resetting successfully initiated!',
          severity: 'success',
        });
      })
      .catch((error) => {
        setSnackbar({
          message: getErrorMessage(
            error,
            get(error, 'errors[0].detail') || 'Reset data failed!',
          ),
          severity: 'error',
        });
        dispatch({ type: RESET_DATA_FAILURE, payload: error });
        throw error;
      });
  };
};
